import { forwardRef, useRef } from 'react';
import './DateTimePicker.scss';
import { dateAndTime } from './dateAndTime';

export const DateTimePicker = forwardRef((props, ref) => {
    const refTime = useRef();

    function handleInputChange() {
        const currentValue = dateAndTime.getDateFromHtml(ref.current.value, refTime.current.value);

        props.onChange({
            target: {
                name: props.name,
                value: currentValue,
            }
        })
    }

    function handleInputBlur(e) {
        const currentValue = dateAndTime.getDateFromHtml(ref.current.value, refTime.current.value);

        props.onBlur({
            target: {
                name: props.name,
                value: currentValue,
            }
        })
    }

    return (
        <div className='date-time-picker'>
            {props.labelArea}
            {props.explanationTextArea}
            <div className='date-time-picker-input-area'>
                <div className={`date-time-picker-input-date ${props.divErrorClass}`}>
                    <input
                        type="date"
                        className={props.className}
                        id={props.name}
                        name={props.name}
                        value={`${dateAndTime.getHtmlDate(props.value)}`}
                        readOnly={(props.readOnly)}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                        onFocus={props.handleOnFocus}
                        ref={ref}
                    />
                    {props.divError}
                </div>

                <input
                    type="time"
                    className={`date-time-picker-input-time ${props.className}`}
                    id={`${props.name}-time`}
                    name={`${props.name}-time`}
                    value={`${dateAndTime.getHtmlTime(props.value)}`}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                    onFocus={props.handleOnFocus}
                    ref={refTime}
                />
            </div>
        </div>
    )
})
